<template>
  <router-link
    custom
    v-slot="{ isActive, href, navigate }"
    :to="props.to"
  >
    <div
      class="header-menu__item"
      :class="{ 'header-menu__item_state_active': isActive }"
    >
      <a :href="href" @click="navigate">{{ props.title }}</a>
    </div>
  </router-link>
</template>

<script lang="ts" setup>
import { RouteLocationRaw } from 'vue-router'

const props = defineProps<{
  title: string
  to: RouteLocationRaw
}>()

</script>
